module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-broken__block"><img class="ggs-gallery-broken__thumb" ng-if="!$ctrl.thumbFailed" roe-style-emitter=":: $ctrl.contentSizeEmitter" roe-style="$ctrl.contentSize" ggs-img-queue ggs-img-queue-src=":: $ctrl.ggsMedia.file_thumb" ggs-img-queue-run-immediately=":: true" ggs-img-queue-events=":: {\n      done: $ctrl.thumbLoadDoneHandler,\n      fail: $ctrl.thumbLoadFailHandler\n    }"> <img class="ggs-gallery-broken__replacer" src="' +
((__t = ( ejs.UNKNOWN_ICON )) == null ? '' : __t) +
'"> ></div>';
return __p
}